import { User } from '@fora-monorepo/employer-my-pages-common/types';
import { getPayloadFromJwtToken } from '@fora-monorepo/webapp-auth';

type TokenData = {
  selectedPartnerNumberOrganization: string | null;
  meta: {
    firstName: string;
    lastName: string;
    pnr: string;
    partnerNumberIndividual: string;
    role: string;
  };
};

export const getUser = (token: string): User => {
  const tokenData: TokenData = getPayloadFromJwtToken(token);

  return {
    firstName: tokenData.meta.firstName,
    lastName: tokenData.meta.lastName,
    pnr: tokenData.meta.pnr,
    partnerNumberIndividual: tokenData.meta.partnerNumberIndividual,
    role: tokenData.meta.role,
    selectedPartnerNumberOrganization: tokenData.selectedPartnerNumberOrganization,
  };
};
